import { render, staticRenderFns } from "./ManageFile.vue?vue&type=template&id=40fff23c"
import script from "./ManageFile.vue?vue&type=script&lang=js"
export * from "./ManageFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports